import React from 'react'

const PayUSuccessRessponse = () => {
  return (
    <div>PayUSuccessRessponse</div>
  )
}

export default PayUSuccessRessponse